import { useSelector, useDispatch } from "react-redux";
import {
  loginUser,
  registerUser,
  logoutUser,
  checkAuthStatus,
} from "../features/auth/authSlice";

export const useAuth = () => {
  const dispatch = useDispatch();
  const {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    onboardingCompleted,
    onboardingSkipped,
  } = useSelector((state) => state.auth);

  const login = async (email, password) => {
    try {
      const result = await dispatch(loginUser({ email, password })).unwrap();
      return result;
    } catch (error) {
      throw error;
    }
  };

  const register = async (userData) => {
    try {
      const result = await dispatch(registerUser(userData)).unwrap();
      return result;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    onboardingCompleted,
    onboardingSkipped,
    login,
    register,
    logout,
  };
};
